import { AggregatedMetrics } from '@prerender/prerender-shared/FE';
import { transformToCategories } from '../../../utils/aggregatedMetricsTransformer';
import { Colors } from '~library/prerenderTheme';

function buildVolumeDatasets(rawData: AggregatedMetrics.PagesCrawledVolumeResult) {
  const transformed = transformToCategories(
    rawData,
    () => 'data',
    (v) => v
  );

  // cover edge cases from tests
  if (!transformed.data) {
    transformed.data = rawData.intervals.map(() => null);
  }

  return [
    {
      label: 'Cache hits',
      data: transformed.data.map(
        (item: AggregatedMetrics.PagesCrawledVolumeResultDataItem) => item?.cache_hit ?? null
      ),
      backgroundColor: Colors.Mint
    },
    {
      label: 'Cache misses',
      data: transformed.data.map(
        (item: AggregatedMetrics.PagesCrawledVolumeResultDataItem) => item?.cache_miss ?? null
      ),
      backgroundColor: Colors.Gold
    }
  ];
}

export default buildVolumeDatasets;
